import { combineEpics, ofType } from 'redux-observable';
import { mapTo, delay, filter } from 'rxjs/operators';
import { get } from 'lodash';

import { login } from 'modules/auth/actions/login';
import defaultPageName from 'modules/auth/constants/defaultPageName';
import { MEDIUM_ANIMATION_DELAY } from 'styleVars/getAnimationDelays';
import { UPDATE_JWT_TOKEN } from 'modules/session/actions/updateJwtToken';
import { GET_SESSION_INFO } from 'modules/session/actions/getSessionInfo';

import { LOGOUT } from '../actions/logout';
import { redirectTo } from '../actions/redirectAction';
import { SUBMIT_LOGIN_FORM } from '../actions/loginForm';
import { EXTERNAL_LOGIN } from '../actions/externalLogin';
import { START_LOCKDOWN, FINISH_LOCKDOWN } from '../actions/lockdown';
import { SUBMIT_IDENTITY_INFO_FORM } from '../actions/identityInfoForm';
import { SUBMIT_ORGANIZATION_SELECTION } from '../actions/organizationSelection';
import { selectOrganizationFromUrl } from '../actions/selectOrganizationFromUrl';
import { TOS_ALREADY_APPROVED, TOS_DECLINE_ACCEPTED } from '../actions/termsOfService';
import { GET_LOGIN_ORGANIZATION_DETAILS } from '../actions/getLoginOrganizationDetails';
import { getOrganizationFromRouter, getExternalUserIdFromRouter } from '../utils/getRouteToRedirect';
import { UNEXPECTED_AUTHORIZATION_ERROR_ACTION, INCORRECT_VERIFICATION_TOKEN_ACTION } from '../actions/commonErrors';

const redirectsToOrganizationSelectionPage = action$ =>
  action$.pipe(
    ofType(
      GET_LOGIN_ORGANIZATION_DETAILS.failure,
      UNEXPECTED_AUTHORIZATION_ERROR_ACTION,
      INCORRECT_VERIFICATION_TOKEN_ACTION,
    ),
    mapTo(() => redirectTo(defaultPageName)),
  );

export const redirectsToLockdownPage = action$ =>
  action$.pipe(
    ofType(START_LOCKDOWN),
    mapTo(() => redirectTo('/lockdown')),
  );


const redirectsToLoginPage = action$ =>
  action$.pipe(
    ofType(
      SUBMIT_ORGANIZATION_SELECTION,
      FINISH_LOCKDOWN,
      LOGOUT.default,
      LOGOUT.success,
      LOGOUT.failure,
      UPDATE_JWT_TOKEN.failure,
      TOS_DECLINE_ACCEPTED,
      GET_SESSION_INFO.failure,
      EXTERNAL_LOGIN.failure,
    ),
    filter((action) => !get(action, 'payload.skipRedirect')),
    mapTo((dispatch, getState) => {
      const state = getState();
      const URLOrganizationId = getOrganizationFromRouter(state);
      const UrlExternalUserId = getExternalUserIdFromRouter(state);

      if (URLOrganizationId && UrlExternalUserId) {
        return dispatch(selectOrganizationFromUrl(URLOrganizationId))
          .then(() => dispatch(login({ externalId: UrlExternalUserId })))
          .then(() => dispatch({ type: SUBMIT_LOGIN_FORM.success }));
      }

      if (URLOrganizationId) {
        dispatch(selectOrganizationFromUrl(URLOrganizationId));
      }

      redirectTo('/login');
    }),
  );

const redirectsToOtpPage = action$ =>
  action$.pipe(
    ofType(
      SUBMIT_IDENTITY_INFO_FORM.success,
      SUBMIT_LOGIN_FORM.success,
    ),
    delay(MEDIUM_ANIMATION_DELAY),
    mapTo(() => redirectTo('/otp-verification')),
  );


const redirectsToHomePageWhenTosApproved = action$ =>
  action$.pipe(
    ofType(
      TOS_ALREADY_APPROVED,
      EXTERNAL_LOGIN.success,
    ),
    delay(MEDIUM_ANIMATION_DELAY),
    mapTo((dispatch, getState) => {
      const state = getState();
      const { routeToRedirect } = state.auth.login;

      return redirectTo(routeToRedirect || '/appointments');
    }),
  );


export default combineEpics(
  redirectsToOrganizationSelectionPage,
  redirectsToLockdownPage,
  redirectsToLoginPage,
  redirectsToOtpPage,
  redirectsToHomePageWhenTosApproved,
);
